import { Navigate, Outlet } from 'react-router-dom';

import { useCompetitionSessionRestore } from '@/hooks/useCompetitionSession';
import { PublicPageShell } from '@/components/layout/PageShell';

/**
 * Protects competition pages (Poczekalnia, Turniej).
 * Restores session from HttpOnly cookie when local store is empty.
 */
export const CompetitionRoute = () => {
  const { status, isDevPreview } = useCompetitionSessionRestore();

  if (isDevPreview) {
    return <Outlet />;
  }

  if (status === 'loading' || status === 'idle') {
    return (
      <PublicPageShell mainClassName="items-center justify-center px-4 py-8">
        <div className="w-full max-w-lg rounded-3xl bg-white/90 px-8 py-10 text-center">
          <svg
            className="mx-auto h-14 w-14 animate-spin text-competition-accent"
            fill="none"
            viewBox="0 0 24 24"
            aria-label="Ładowanie..."
            role="status"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="3"
            />
            <path
              className="opacity-80"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
            />
          </svg>
          <p className="mt-5 text-base font-medium text-gray-500">Przywracanie sesji...</p>
        </div>
      </PublicPageShell>
    );
  }

  if (status === 'denied') {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};
